module.exports = __webpack_public_path__ + "static/media/ibm.6ad6394c.svg";